import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../images/logo-cargonz.png'
import '../styles/Login.css'

class Login extends React.Component {
    render(){
        return (
            <React.Fragment>
                <div className="loginContainer">
                    <div className="loginForm position-relative">
                        <Link to="/" className="btn btn-outline-danger position-absolute loginCerrar">X</Link>
                        <div className="loginFormIcon">    
                        </div>
                        <div className="loginFormInfo">
                            <img src={logo} alt="logotipo"/>
                            <form className="loginFormForm">
                                <div className="form-group">
                                    <input type="text" className="form-control" placeholder="Nombre de usuario"/>
                                </div>
                                <div className="form-group">
                                    <input type="password" className="form-control" placeholder="Contraseña"/>
                                </div>
                                <button type="submit" className="btn btn-danger">Iniciar sesión</button>
                                <Link to="/signin">Crear una cuenta</Link>
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default Login